import {
  Button,
  Card,
  CardActions,
  CardContent,
  colors,
  Grid,
  Modal,
  TextField,
  Theme,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import {T} from 'react-polyglot-hooks';
import {Resource} from '../../../graphql/resources.datatypes';
import moment, {Moment} from 'moment';
import anyLoading from '../../../utils/anyLoading';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import availableTours from './getAvailableTours.api';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: '95%'
  },
  container: {
    marginTop: theme.spacing(3)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  },
  submitButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  }
}));

export const checkRoomAvailable = (hotel: Resource, start: Moment, end: Moment, capacity?: number) => {
  const dayCount = end.diff(start, 'days');
  const passed = hotel.roomResources && hotel.roomResources
      .filter(roomResource => (capacity !== undefined && capacity > 0) ? roomResource.guest_capacity! >= capacity : true)
      .map(roomResource => {
        if (!roomResource.resource_banks) return false;
        const dayRange = roomResource.resource_banks && roomResource.resource_banks
            .filter(resourceBank => {
              const date = moment(new Date(resourceBank.date!));
              return date.isSameOrAfter(start, 'days') && date.isBefore(end, 'days') && resourceBank.remaining! > 0;
            });
        return roomResource.allow_manual_overbooking || (dayRange && dayRange.length === dayCount);
      })
      .find(pass => pass === true);
  return passed === true;
};

const AvailableToursModal = (props: {
  className?: string,
  onClose: () => void,
  onConfirmClick: (hotel?: Resource) => void,
  open: boolean,
  currentTourId: number,
}) => {
  const {open, onClose, onConfirmClick, currentTourId, ...rest} = props;
  const classes = useStyles();
  const toursData = availableTours();
  const loadingData = anyLoading(toursData)
  const [selectedTourId, setSelectedTourId] = useState<number>(currentTourId);

  const getSelectedHotel = () => toursData.data!.availableTours.find(tour => tour.id === selectedTourId);

  if (!open) {
    return null;
  }

  return (
      <Modal onClose={onClose} open={open}>
        <Card {...rest} className={clsx(classes.root)}>
          <form>
            <LoadingOverlay loading={loadingData.loading}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography gutterBottom variant="h3">Select Available Tour</Typography>

                    {currentTourId > -1 && (
                        <Typography variant="body1" color={'error'}>
                          Warning! You are about to change the tour for a group. Please be sure about this update as it
                          could cause problems and cannot be undone.<br/><br/>
                        </Typography>
                    )}

                    {loadingData.loading && (
                        <span>please wait...</span>
                    )}
                    {!loadingData.loading && (<TextField
                            fullWidth
                            label="Tour"
                            name="tour_resource_id"
                            onChange={(event) => setSelectedTourId(Number(event.target.value))}
                            select
                            // eslint-disable-next-line react/jsx-sort-props
                            SelectProps={{native: true}}
                            value={selectedTourId}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                        >
                          <option value={-1}>Please select...</option>
                          {toursData.data && toursData.data.availableTours && toursData.data.availableTours.map((tour) => (
                              <option key={tour.id} value={tour.id}>
                                {tour.internal_name}
                              </option>
                          ))}
                        </TextField>
                    )}

                  </Grid>
                </Grid>
              </CardContent>


              <CardActions className={classes.actions}>
                <Button onClick={() => {
                  onClose();
                }} variant="contained">
                  <T phrase="Cancel"/>
                </Button>
                <Button
                    className={classes.submitButton}
                    onClick={() => {
                      onClose();
                      onConfirmClick(getSelectedHotel());
                    }}
                    variant="contained"
                >
                  <T phrase="Confirm"/>
                </Button>
              </CardActions>
            </LoadingOverlay>
          </form>
        </Card>
      </Modal>
  );
};

export default AvailableToursModal;
